import type { SVGProps } from "react";

export default function ClipboardListIcon(
  props: Readonly<SVGProps<SVGSVGElement>>,
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M7.5 3.333H5.833c-.92 0-1.666.747-1.666 1.667v10c0 .92.746 1.667 1.666 1.667h8.334c.92 0 1.666-.746 1.666-1.667V5c0-.92-.746-1.667-1.666-1.667H12.5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 3.333c0-.92.746-1.666 1.667-1.666h1.666c.92 0 1.667.746 1.667 1.666 0 .92-.746 1.667-1.667 1.667H9.167c-.92 0-1.667-.746-1.667-1.667Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 9.167h5M7.5 12.5h5"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
